module.exports = __webpack_public_path__ + "img/Logo8i2.8c589bd2.png";